module.exports = __webpack_public_path__ + "img/home_off.97b45b22.svg";